import React, { FC, ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { ReactComponent as ArrowDownIcon } from "src/assets/icons/arrow-down.svg";
import { Button } from "../Button";
import { ButtonVariants } from "../Button/types";
import { collapsibleBannerTrns } from "./trns";

interface Props {
  children: ReactNode;
  className?: string;
}

export const CollapsibleBanner: FC<Props> = ({ children, className }) => {
  const { t } = useTranslation();

  const [isShownMore, setIsShownMore] = useState(false);

  const toggleShowMore = () => setIsShownMore((prev) => !prev);

  return (
    <div
      className={cn(
        "flex flex-1 flex-col gap-2 p-3 pb-0 border border-black-base/20 rounded-20 md:p-5 md:pb-0",
        className
      )}
    >
      <div
        className={cn(
          "transition-all duration-300 ease-in-out overflow-hidden",
          {
            "max-h-12.5 opacity-80": !isShownMore,
            "max-h-125 opacity-100": isShownMore,
          }
        )}
      >
        {children}
      </div>
      <Button
        type="button"
        className="flex gap-2 items-center !bg-inherit justify-center py-1 px-4 rounded-b-none border-b-0 mx-auto text-sm md:py-2 md:px-7 md:text-base md:pb-2"
        onClick={toggleShowMore}
        variant={ButtonVariants.SECONDARY}
      >
        <ArrowDownIcon
          className={cn("w-4 h-4 md:w-5 md:h-5", {
            "rotate-180": isShownMore,
          })}
        />
        {isShownMore
          ? t(collapsibleBannerTrns.showLessBtn)
          : t(collapsibleBannerTrns.showMoreBtn)}
      </Button>
    </div>
  );
};
